<template>
	<div class="createcwbill" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }" v-if="isload">
		<el-form>
			<el-row>
				<maininfo :ref="'createcwbill_'+l_id" v-if="type == '应收'||type == '应付'||type == '已收'||type == '已付'||type == '预收'||type == '预付'" :item="item" :l_id="l_id" @maincallback="maincallback"></maininfo>
			</el-row>
			<el-row>
				<gridlist :ref="'cwbillfeelist_'+l_id" v-if="type == '应收'||type == '应付'||type == '已收'||type == '已付'" :item="item" :l_id="l_id" :gridsum="true" :isdetail="(type=='已收'||type=='已付'||isdetail)" :checkcountsum="(type=='已收'||type=='已付')" @gridcallback="gridcallback"></gridlist>
			</el-row>
		</el-form>

		<el-row class="footerhandler" v-if="!btndisabled&&!isdetail">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
import gridlist from '@/components/tools/gridlist.vue';
export default {
	components: {
		maininfo,
		gridlist
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:'',
			l_id:'',
			isedit:'',
			btndisabled:false,
			isload:false,
			createcwbill_lang:{},
			windowHeight: window.innerHeight - 120,
			t_id:'',
			pagetranscol:'',
			sumarycol:{
				 cols:['price','num'],//参与计算的列
				 triggercols:['price','num'],//参与计算的列
				 counttype:'*',//两个列相乘
				 //groupcol:'currency',//按此字段分组汇总
			 },
			 isdetail:false
		};
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/createcwbill.scss');
		this.init();
	},
	methods:{
		init(){
			if (this.urlparam != undefined) {
				this.type=this.item.l_tablename;
				this.pageparam = this.urlparam;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
					if (this.urlparam.iscopy != undefined) {
						this.iscopy = this.urlparam.iscopy;
					}
				}
				if(this.urlparam.isedit!=undefined)
					this.isedit=this.urlparam.isedit;	
				if(this.urlparam.isdetail!=undefined)
					this.isdetail=this.urlparam.isdetail;	
			}
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('createcwbill',this).then(res=>{
				if(res.state=='1')
					that.createcwbill_lang=that.$lang.label.createcwbill;
				if(this.curpkval!='')//加载账单
					this.GetOrderInfo();
				else
					this.GetPageLayout();
			});
		},
		GetOrderInfo(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					that.orderinfo = res;
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				this.$tool.loadingclose();
				var t_id="",pagetranscol="",syscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
							syscol= res.set.t_syscol
						}
					}
					var list=[];
					if(t_id==''&&res.list!=undefined){
						list = res.list.filter(function(re) {
							return re.t_type == that.type;
						});
						if(list.length>0){
							t_id = list[0].t_id;
							pagetranscol=list[0].pagetranscol;
							syscol= list[0].t_syscol;
						}
					}
					if(t_id!=''){
						that.t_id=t_id;
						that.isload=true;
						that.pagetranscol=pagetranscol;
						if(that.orderinfo!='')
							that.orderinfo = that.$tool.TransOrderInfo(pagetranscol, that);
						
						if (that.type  == '应收'||that.type == '应付'||that.type == '已收'||that.type == '已付'||that.type == '预收'||that.type == '预付') {
							that.$nextTick(function(){
								that.$refs['createcwbill_'+that.l_id].init({pkval:that.curpkval,iscopy:that.iscopy,type:that.type,orderinfo:that.orderinfo,syscol:syscol,t_id: t_id,isdetail:that.isdetail});
								
								if(that.type=='已收'||that.type=='已付')
									that.sumarycol={ 
										cols:['price'],//参与计算的列
									    triggercols:['price'],//参与计算的列
									    counttype:'+',//加
									 }
								if(that.type!='预付'&&that.type!='预收'){
									that.$refs['cwbillfeelist_'+that.l_id].init(
									{
									 pkval:that.curpkval,
									 iscopy:that.iscopy,
									 type:that.type,
									 orderinfo:that.orderinfo,
									 syscol:syscol,
									 t_id: t_id,
									 ischecked:(that.type == '已收'||that.type == '已付')?true:false,
									 sumarycol:that.sumarycol
									});
								}
							});
						}
					}
				}
			});
		},
		saveorder() {
			var that=this;
			var orderinfo=this.$tool.getOrderinfo(this.$refs['createcwbill_'+this.l_id]._data,this.p_no,this);
			if(orderinfo!=''){
				//debugger
				if(that.type=='应收'&&that.type=='应付')
					orderinfo=this.$tool.getOrderinfo(this.$refs['cwbillfeelist_'+this.l_id]._data,this.curpkval,this,orderinfo);
				else{
					if(that.type=='已收'||that.type=='已付')
					{
						var list=this.$refs['cwbillfeelist_'+this.l_id]._data.checkedrows;
						if(list.length>0)
							orderinfo.list=list;
						else
						{
							this.$tool.message(that.createcwbill_lang.nocheckedorder, "0");
							orderinfo='';
						}
					}
				}
			}
			if(orderinfo!=''){
				//debugger
				orderinfo.u_userid=localStorage.getItem('userid');
				orderinfo.t_id=that.t_id;
				orderinfo.editid=this.curpkval;
				this.btnhidden=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					this.btnhidden=false;
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function(){
							that.cancel();
						},1000);
					}
					else
						this.$tool.message(res.message, "0");
						//this.$tool.message(that.baojia_lang[res.message], "0");
				});
			}
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		maincallback(e){
			var that=this;
			if(e.event=='getperbill'){
				//debugger
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				var paraminfo={
					pkval:e.crm_c_id,
					l_id:this.l_id
				}
				this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if(res.list!=undefined){
							if(res.list.length>0){
								if(that.orderinfo=='')
									that.orderinfo={list:res.list};
								else
									that.orderinfo.list=res.list;
								
								//debugger
								that.orderinfo= that.$tool.TransOrderInfo(that.pagetranscol, that);
								
								if(that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo=='')
								{
									that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo=that.orderinfo;
								}
								else
									that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo.list=that.orderinfo.list;
								that.$refs['cwbillfeelist_'+that.l_id].setpagelayout();
							}
							else
							{
								if(that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo=='')
									that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo={list:res.list};
								else
									that.$refs['cwbillfeelist_'+that.l_id]._data.orderinfo.list=[];
								that.$refs['cwbillfeelist_'+that.l_id].setpagelayout();	
								
								if(that.type=='已付')
									this.$tool.message(that.createcwbill_lang.nopaidingorder, "0");
								else
									this.$tool.message(that.createcwbill_lang.nochckoutorder, "0");
							}
						}
					} 
					else
					{
						if(that.type=='已付')
							this.$tool.message(that.createcwbill_lang.nopaidingorder, "0");
						else
							this.$tool.message(that.createcwbill_lang.nochckoutorder, "0");
					}
				});
			}
		},
		gridcallback(e){
			if(e.event=='getsum'){
				//列表勾选的总金额回填到指定字段
				var list=[];
				if(e.rows!=undefined){
					list=e.rows.filter(function(b){
						return b.p_sourcemode=='预付账单'||b.p_sourcemode=='预收账单';
					});
				}
				this.$refs['createcwbill_'+this.l_id].setinputenable({colname:'perpay',disenabeld:false});
				if(list.length>0){
					//包含预收或者预付的账单，预付金额不可以输入
					this.$refs['createcwbill_'+this.l_id].setinputenable({colname:'perpay',disenabeld:true});
				}
				this.$refs['createcwbill_'+this.l_id].setinputvalue({colname:'other_fee',value:e.amount});
			}
		}
	}
};
</script>
